import { CategoryType } from '@wwe-portal/entities/offer.type';
import { QUERY_KEY_OFFER_V2 } from '@wwe-portal/web/utils/constants/keys';

export const getOfferByIdKey = (offerId: string) => {
  return [QUERY_KEY_OFFER_V2, { offerId }];
};

export const getConsolidatedOffersKey = ({
  categories,
  userId,
  isAuthenticated,
}: {
  categories?: CategoryType[];
  userId?: string;
  isAuthenticated: boolean;
}) => {
  return [
    'consolidated-offers',
    { categories, userId, isAuthenticated },
  ] as const;
};
